import { render, staticRenderFns } from "./pushProject.vue?vue&type=template&id=531efc69&scoped=true&"
import script from "./pushProject.vue?vue&type=script&lang=js&"
export * from "./pushProject.vue?vue&type=script&lang=js&"
import style0 from "./pushProject.vue?vue&type=style&index=0&id=531efc69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531efc69",
  null
  
)

export default component.exports